import React, { useEffect, useRef, useState } from 'react';
import { ChatMessage, ChatResponse, ConversationRequest, FlowType, MessageType, conversationApi } from '../../api';
import uuid from 'react-uuid';
import { DefaultButton } from '@fluentui/react';

interface SuggestionsProps {
    // Define your props here
    answer: any;
    populateInAnswer: Function;
    currentAssessmentQuestion?: string | null;
    styles: any;
    scroll: Function;
}

const [ASSISTANT, TOOL, ERROR] = ["assistant", "tool", "error"]

const Suggestions: React.FC<SuggestionsProps> = ({
    answer,
    populateInAnswer,
    currentAssessmentQuestion,
    styles,
    scroll
}) => {
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState<string[]>([]);
    const abortFuncs = useRef([] as AbortController[]);

    useEffect(() => {
        if (currentAssessmentQuestion) {
            makeApiRequestWithoutCosmosDB(currentAssessmentQuestion);
        }
    }, []);

    useEffect(() => {
        scroll()
    }, [options]);

    const stopRequest = () => {
        abortFuncs.current.forEach(a => a.abort());
        setLoading(false)
    }


    let assistantMessage = {} as ChatMessage
    let toolMessage = {} as ChatMessage
    let assistantContent = ""

    const processResultMessage = (resultMessage: ChatMessage, userMessage: ChatMessage, conversationId?: string) => {
        if (resultMessage.role === ASSISTANT) {
            assistantContent += resultMessage.content
            assistantMessage = resultMessage
            assistantMessage.content = assistantContent
            assistantMessage.messageType = MessageType.Text

            if (resultMessage.context) {
                toolMessage = {
                    id: uuid(),
                    role: TOOL,
                    content: resultMessage.context,
                    date: new Date().toISOString(),
                    flowtype: resultMessage.flowtype,
                    messageType: MessageType.Text,
                }
            }
        }

        if (resultMessage.role === TOOL) toolMessage = resultMessage
    }


    const makeApiRequestWithoutCosmosDB = async (question: string, conversationId?: string, flType?: FlowType) => {

        setLoading(true);

        const userMessage: any = {
            id: uuid(),
            role: "user",
            content: question,
            date: new Date().toISOString(),
            flowtype: FlowType.AssessmentHelper,
            messageType: MessageType.Text,
            currentAssessmentFlow: sessionStorage.getItem('CurrentAssessmentFlow') || "",
        };

        let request: ConversationRequest = {
            messages: [userMessage]
        };

        let result = {} as ChatResponse;

        const abortController = new AbortController();
        abortFuncs.current.unshift(abortController);

        try {
            const response = await conversationApi(request, abortController.signal);
            if (response?.body) {
                const reader = response.body.getReader();

                let runningText = "";
                while (true) {
                    const { done, value } = await reader.read();
                    if (done) break;

                    var text = new TextDecoder("utf-8").decode(value);
                    const objects = text.split("\n");
                    objects.forEach((obj) => {
                        try {
                            if (obj !== "" && obj !== "{}") {
                                runningText += obj;
                                result = JSON.parse(runningText);
                                if (result.choices?.length > 0) {
                                    result.choices[0].messages.forEach((msg) => {
                                        msg.id = result.id;
                                        msg.date = new Date().toISOString();
                                    })
                                    if (result.choices[0].messages?.some(m => m.role === ASSISTANT)) {
                                        setLoading(false);
                                    }
                                    result.choices[0].messages.forEach((resultObj) => {
                                        processResultMessage(resultObj, userMessage, conversationId);
                                    })
                                }
                                else if (result.error) {
                                    throw Error(result.error);
                                }
                                runningText = "";
                            }
                        }
                        catch (e) {
                            if (!(e instanceof SyntaxError)) {
                                console.error(e);
                                throw e;
                            } else {
                                console.log("Incomplete message. Continuing...")
                            }
                        }
                    });
                }
            }

            setOptions(assistantMessage.content?.split(";").filter((item) => item !== ""));

        } catch (e) {

        } finally {
            setLoading(false);
            abortFuncs.current = abortFuncs.current.filter(a => a !== abortController);
        }

        return abortController.abort();
    };



    return (
        <div>
            {loading ? <div>Loading...</div> :
                <div className={styles.chatMessageUserButtonContainer}>
                    {options.map((option, index) => (
                        <DefaultButton
                            key={index}
                            className={styles.chatMessageUserButton}
                            text={option}
                            onClick={() => populateInAnswer(option)}
                        />

                    ))}
                </div>
            }
        </div>
    );
};

export default Suggestions;